// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*purgecss start ignore*/\n.dropdown-choosen .el-dropdown-link{\n  border:1.42077px solid #26d226;\n  box-sizing:border-box;\n  border-radius:7px;\n  width:160px\n}\n.dropdown-choosen .el-dropdown-link .text-absolute{\n  position:absolute;\n  top:12px;\n  bottom:0;\n  left:13px;\n  margin:auto\n}\n\n/*purgecss end ignore*/", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
